import {RequestFailedError} from '../../common/errors';
import {getLocale} from '../../common/locale';
import ProductCustomizationConfigModel from '../Model/productCustomizationConfigModel';

export type UpdatePricingOverviewResponse = string;

export default class CustomizationOverviewMapper {
    private static readonly URL_UPDATE_CUSTOMIZATION_OVERVIEW: string = `/${getLocale()}/product-customization/apiUpdatePricingOverview/`;

    async fetchPricingOverview(config: ProductCustomizationConfigModel, browserTabUid: string): Promise<UpdatePricingOverviewResponse | RequestFailedError> {
        const formData = config.getAsFormdata();
        formData.append('browserTabUid', browserTabUid);

        const request = await fetch(CustomizationOverviewMapper.URL_UPDATE_CUSTOMIZATION_OVERVIEW, {
            method: 'POST',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            cache: 'no-cache',
            credentials: 'same-origin',
            body: formData,
        });

        if (request.status !== 200) {
            return new RequestFailedError();
        }

        return await request.text();
    }
}
